import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { installBranchFetch } from './utils/branchFetch';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
const PRINTER_URL = import.meta.env.VITE_PRINTER_URL || API_URL;
// PRINTER_URL รวมด้วยแล้ว — Local API (server.js) เปิด X-Branch-Id/X-Branch-Scope ใน CORS
// allowlist แล้วตั้งแต่วันที่แก้เคส 304 (เดิมไม่รวมเพราะกลัว preflight บล็อกตอนที่ยังไม่ได้
// แก้ CORS ฝั่งนั้น) สาขาที่ยังไม่ได้ deploy โค้ดใหม่จะยัง CORS-block เหมือนเดิม ไม่ได้แย่ลง
// กว่าที่เป็นอยู่ (Dashboard.jsx/Checkout.jsx ก็แนบ header เองอยู่แล้วสำหรับ endpoint พวกนั้น)
installBranchFetch([API_URL, PRINTER_URL]);

const appRoot = document.getElementById('app');

if (appRoot) {
  ReactDOM.createRoot(appRoot).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
